module.exports = __webpack_public_path__ + "img/logo.7b986e2e.svg";